import { Injectable } from '@angular/core';
import { firstValueFrom, fromEvent, Observable, takeUntil } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BookingGuestListRequestBody, BookingGuestListResponse } from '../Models/booking-guest';

@Injectable({
  providedIn: 'root',
})
export class BookingGuestsService {
  OBPortalSvcURL = '';
  headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient) {
      this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
  }

  public GetBookingGuests(bookingID: number | undefined): Observable<BookingGuestListResponse> {
    const bookingInfo = new BookingGuestListRequestBody(bookingID);

    return this.httpClient.post<BookingGuestListResponse>(`${this.OBPortalSvcURL}GetBookingGuests`, bookingInfo, { headers: this.headers });
  }


  public async GetBookingGuestsAsync(bookingID: number|undefined, abortControl: AbortController): Promise<BookingGuestListResponse> {
       const bookingInfo = new BookingGuestListRequestBody(bookingID);
       const aborted$ = fromEvent(abortControl.signal, 'abort');
       return await firstValueFrom(
          this.httpClient
            .post<BookingGuestListResponse>(
              `${this.appConfigService.ProxyUrl}${this.OBPortalSvcURL}GetBookingGuests`, 
              bookingInfo,
              { headers: this.headers }
            )
            .pipe(takeUntil(aborted$))
        );
  }



}
